import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import DashboardBalance from "@/pages/DashboardBalance";
import DashboardCategories from "@/pages/DashboardCategories";
import Expenses from "@/pages/Expenses";
import CategoriesAdmin from "@/pages/CategoriesAdmin";
import Budget from "@/pages/Budget";
import DataManagement from "@/pages/DataManagement";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Navigate to="/spese" replace />} />
            <Route path="/saldo" element={<DashboardBalance />} />
            <Route path="/categorie" element={<DashboardCategories />} />
            <Route path="/spese" element={<Expenses />} />
            <Route path="/budget" element={<Budget />} />
            <Route path="/dati" element={<DataManagement />} />
            <Route path="/impostazioni" element={<CategoriesAdmin />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
